import type { CamelCasedPropertiesDeep } from 'type-fest';

import { Codeowners } from '../../consts/codeowners';
import { mapResponseToCamelCase } from '../../state/utils';
import { catchNetworkExceptions, mapNetworkStatuses } from '../../utils/exception';
import { PaymentRestAPI } from '../restApi';

export type InvoiceDataResponse = {
  amount: number;
  due_amount: number;
  subtotal: number;
  total: number;
  invoice_number: string;
  payment_options: {
    cc_enabled: boolean;
    ach_enabled: boolean;
    can_save_card_on_file: boolean;
    can_pay_online: boolean;
  };
  status: string;
  invoice_count: number;
  template: 'deposit' | unknown;
};

export type InvoiceData = CamelCasedPropertiesDeep<InvoiceDataResponse>;

export type PaymentByCardPayload = {
  amount: number;
  fixed_gratuity: number;
  stripe_cc_token: string;
  save_card_on_file: boolean;
  card_on_file_email: string;
};

export type PaymentStatus = 'initiated' | 'pending' | 'succeeded' | 'failed';

export type PayByCardResponse = {
  status: PaymentStatus;
  object: 'invoice_payment';
};

export type PaymentStatusResponse = {
  status: PaymentStatus;
};

export const paymentRequests = {
  fetchInvoice: (invoiceToken: string) => {
    return catchNetworkExceptions(
      () =>
        PaymentRestAPI.get<InvoiceData>(`/api/invoices/consumer/v1/invoices/${invoiceToken}`).then(
          mapResponseToCamelCase
        ),
      Codeowners.CUSTOMER_INTAKE,
      mapNetworkStatuses
    );
  },
  payByCard: ({ invoiceToken, payload }: { invoiceToken: string; payload: PaymentByCardPayload }) => {
    return catchNetworkExceptions(
      () =>
        PaymentRestAPI.postWithFormData<PayByCardResponse, PaymentByCardPayload>(
          `/api/invoices/consumer/v1/invoices/${invoiceToken}/payments/by_credit_card`,
          payload
        ),
      Codeowners.CUSTOMER_INTAKE,
      mapNetworkStatuses
    );
  },
  fetchPaymentStatus: (invoiceToken: string) => {
    return catchNetworkExceptions(
      () => PaymentRestAPI.get<PaymentStatusResponse>(`/api/invoices/consumer/v1/invoices/${invoiceToken}/payments`),
      Codeowners.CUSTOMER_INTAKE,
      mapNetworkStatuses
    );
  },
};
